import { render } from "./CreateBuddy.vue?vue&type=template&id=36837cb3&scoped=true"
import script from "./CreateBuddy.vue?vue&type=script&lang=js"
export * from "./CreateBuddy.vue?vue&type=script&lang=js"

import "./CreateBuddy.vue?vue&type=style&index=0&id=36837cb3&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36837cb3"]])

export default __exports__